export const defaultColumns = [
  { label: "Status", value: "status" },
  { label: "Nome", value: "display_name" },
  { label: "Cidade", value: "city_state" },
  { label: "Faturamento", value: "lifetime_revenue_amount", className: "w-44" },
  { label: "Total em tarifas", value: 'unpaid_fees_total', className: "w-44"},
  { label: "A pagar", value: "receivable_amount", className: "w-44 text-amber-200" },
  { label: "Usuários", value: "users_count", className: "w-20" },
  { label: "Ações", value: "actions", className: "w-10" },
];
